'use strict';

i18nFilter.$inject = ['mx.internationalization'];
export function i18nFilter(i18n) {
	return function (string) {
		return i18n.get(string);
	};
}
